import * as APIModels from "../../../models";
import { useState, useEffect } from "react";
import { ClientService } from "../../../services/ClientService";
import { DataService } from "../../../services/DataService";
import { ReportService } from "../../../services/SubmissionService";

export default function Fees({
    submission,
    fees,
    handleFeeLoading,
    onFeeChange,
}: {
    submission: APIModels.Submission;
    fees: APIModels.FeeType[];
    handleFeeLoading: (value: boolean) => void;
    onFeeChange: (fees: APIModels.FeeType[]) => void;
}) {
    const [completedFees, setCompletedFees] = useState(fees);
    const [caseData, setCaseData] = useState(new APIModels.CaseData());

    // Need to add a state variable to set the button to be a loading variable

    useEffect(() => {
        if (
            submission.caseData?.caseSubTypeID != caseData?.caseSubTypeID ||
            submission.caseData?.caseTypeID != caseData?.caseTypeID ||
            submission.caseData?.courtCaseNumber
        ) {
            console.log("firing");
            handleFeeLoading(true);
            setCaseData(submission.caseData ?? new APIModels.CaseData());
            ClientService.getFees({
                body: {
                    filename: submission.filename,
                    docs: submission.documents ?? [],
                    submissionID: caseData?.submissionID,
                    attorneyID: submission.attorneyID,
                    caseTypeID:
                        submission.caseData?.caseSubTypeID ??
                        submission.caseData?.caseTypeID,
                    countyID: submission.caseData?.countyID,
                    divisionID: submission.caseData?.divisionID,
                    newCase: submission.filename!.indexOf("-a-") > -1,
                    summonsCount: submission.caseData?.summonsCount,
                },
            }).then(
                (resp) => {
                    console.log(resp);
                    if (resp.successful && resp.data) {
                        setCompletedFees(resp.data);
                        onFeeChange(resp.data);
                        handleFeeLoading(false);
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [submission]);

    if (!completedFees) return <div></div>;

    return (
        <div className="mb-3">
            <div className="row">
                {completedFees?.map((fee, i) => {
                    return (
                        <div className="col-6">
                            <div className="row">
                                <div className="col-6">
                                    <label style={{ fontWeight: "bold" }}>
                                        {fee.description}
                                    </label>
                                </div>
                                <div
                                    className="col-2"
                                    style={{
                                        height: 40,
                                        verticalAlign: "center",
                                        lineHeight: "40px",
                                        fontWeight: "bold",
                                        padding: 0,
                                    }}
                                >
                                    {`$${fee.amount}`}
                                </div>
                                <div className="col-4" style={{ padding: 0 }}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id={`fee-input-${i}`}
                                        aria-describedby="inputGroupPrepend"
                                        onChange={(event) => {
                                            const updatedFees = [...fees];
                                            updatedFees[i].quantity = parseInt(
                                                event.currentTarget.value
                                            );
                                            setCompletedFees([...updatedFees]);
                                            onFeeChange(updatedFees);
                                        }}
                                        value={fee.quantity}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
